import React, { useState, useRef } from "react";
import cx from "classnames";
import useSWR, { mutate } from "swr";
import { makeRequest, fetcher } from "../../utils/request";
import constants from "../../config/constants";
import LogsService from "../../utils/logs";
import Select from 'react-select'
import { sanitizeFormInput } from "../../utils/helper";
import { pushDatatoAdobeLayer } from "../../analytics/pmiAdobeLog";
import { getAdobeAnalyticsEventObject, getAdobeAnalyticsCustomLinkObj } from '../../analytics/analyticsObject';
import {

  getUrlWithoutPathname,

} from "../../utils/utility";
const FeedbackForm = ({ contentKey, onSubmit, feedbacks, post }) => {
  const [messageValue, setMessageValue] = useState("");
  const [ratingValue, setRatingValue] = useState("");
  const [mostValuable, setMostValuable] = useState("");
  const [updateFrequency, setUpdateFrequency] = useState("");
  const [costPreference, setCostPreference] = useState("");
  const [likelyActions, setLikelyActions] = useState([]);
  const [notificationPreference, setNotificationPreference] = useState("");
  const [otherNotification, setotherNotification] = useState("");
  const [improvementsValue, setimprovementsValue] = useState("");
  const [focusedEmoji, setFocusedEmoji] = useState("");
  const [userInteracted, setuserInteracted] = useState(false);
  const swrOptions = {
    revalidateOnFocus: false,
  };
  const likelyActionsOptions = [
    "Very Likely",
    "Likely",
    "Not Likely",
  ]

  const satisfiedEmoji = useRef();
  const neutralEmoji = useRef();
  const unsatisfiedEmoji = useRef();


  const groupKey = contentKey ? constants.commentGroupKeys.content : constants.commentGroupKeys.general;
  const groupTitle = contentKey ? constants.commentGroupTitles.content : constants.commentGroupTitles.general;
  const satisfied = "satisfied";
  const neutral = "neutral";
  const unsatisfied = "unsatisfied";

  const { data: contentTypeOptions } = useSWR(
    `/api/commentoptions/query?groupKey=${groupKey}`,
    fetcher,
    swrOptions
  );

  const likelyActionsCount = contentTypeOptions?.filter(option => option.type === constants.commentOptionGroupKeys.LikelyActions).length;

  const isMessageValid = () => messageValue !== "";
  const isRatingValid = () => ratingValue !== "";
  const isImprovementsValid = () => improvementsValue !== "";
  const isMostValuableValid = () => mostValuable !== "";
  const isUpdateFrequencyValid = () => updateFrequency !== "";
  const isCostPreferenceValid = () => costPreference !== "";
  const isLikelyActionsValid = () => (likelyActions.length >= likelyActionsCount);
  const isNotificationPreferenceValid = () => notificationPreference !== "";
  const isOhterNotificationValid = () => otherNotification !== "";

  const formFilled = () => {
    if (contentKey) {
      return (
        isMessageValid() &&
        isRatingValid() &&
        isImprovementsValid()
      );
    } else if (notificationPreference?.value?.name == "Other") {
      return (
        isMessageValid() &&
        isRatingValid() &&
        isMostValuableValid() &&
        isUpdateFrequencyValid() &&
        isOhterNotificationValid() &&
        isCostPreferenceValid() &&
        isLikelyActionsValid()
      );
    } else {
      return (
        isMessageValid() &&
        isRatingValid() &&
        isMostValuableValid() &&
        isUpdateFrequencyValid() &&
        isNotificationPreferenceValid() &&
        isCostPreferenceValid() &&
        isLikelyActionsValid()
      );
    }
  };

  const commentSubType = {
    groupKey: groupKey,
    groupTitle: groupTitle
  };

  const submitForm = async () => {

    let content;
    const sanitizedMessageValue = sanitizeFormInput(messageValue)

    if (contentKey) {

      // Content Feedback Form

      content = {
        message: sanitizedMessageValue,
        mood: ratingValue,
        improvements: sanitizeFormInput(improvementsValue),
      };

    } else {

      // General Feedback From

      const communicationMode = notificationPreference?.value?.name == "Other"
        ? { id: notificationPreference.value.id, name: notificationPreference.value.name, other: otherNotification }
        : { id: notificationPreference.value.id, name: notificationPreference.value.name };

      content = {
        message: sanitizedMessageValue,
        mood: ratingValue,
        communicationFrequency: { id: updateFrequency.value.id, name: updateFrequency.value.name },
        valuableFeatures: mostValuable,
        communicationMode: communicationMode,
        costPreference: { id: costPreference.value.id, name: costPreference.value.name },
        likelyActions: likelyActions,
      };

    }

    const data = {
      contentKey: contentKey ? contentKey : constants.contentKeys.generalFeedbackForm,
      content: JSON.stringify(content),
      commentType: constants.commentTypes.feedback,
      commentSubType: commentSubType
    };

    await makeRequest("POST", `/api/comment`, data);

    onSubmit();
    await LogsService.logFeedbackSent(content);

  };

  const getCommentOptions = (type) => {

    const selectOptions = contentTypeOptions
      ?.filter(option => option.type == type)
      .map(option => ({ label: option.name, value: option }));

    return selectOptions;

  }

  const handleEmojiKeyPres = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setRatingValue(e.target.getAttribute('id'));
    }
  }

  const handleRationgValueChange = (e) => {
    handleEmojiClick(e.target.value);
  }

  const handleEmojiFocus = (e) => {
    setFocusedEmoji(e.target.value);
  }

  const handleEmojiClick = (rating) => {
    switch (rating) {
      case satisfied:
        satisfiedEmoji.current.checked = true;
        satisfiedEmoji.current.focus({ preventScroll: true });
        setFocusedEmoji(satisfied);
        setRatingValue(satisfied);
        break;
      case neutral:
        neutralEmoji.current.checked = true;
        neutralEmoji.current.focus({ preventScroll: true });
        setFocusedEmoji(neutral);
        setRatingValue(neutral);
        break;
      case unsatisfied:
        unsatisfiedEmoji.current.checked = true;
        unsatisfiedEmoji.current.focus({ preventScroll: true });
        setFocusedEmoji(unsatisfied);
        setRatingValue(unsatisfied);
        break;
    }
  }

  const handleEmojiBlur = (rating) => {
    switch (rating) {
      case satisfied:
        satisfiedEmoji.current.blur();
        setFocusedEmoji("");
        break;
      case neutral:
        neutralEmoji.current.blur();
        setFocusedEmoji("");
        break;
      case unsatisfied:
        unsatisfiedEmoji.current.blur();
        setFocusedEmoji("");
        break;
    }
  }

  const handleLikelyActionsChange = (likelyAction, value) => {
    const likelyActionIndex = likelyActions.findIndex((selectedLikelyAction) => selectedLikelyAction.id === likelyAction.id)
    const newLikelyActions = [...likelyActions];
    const newLikelyAction = { id: likelyAction.id, name: likelyAction.name, value: value };
    if (!likelyActionIndex) { newLikelyActions[likelyActionIndex] = newLikelyAction; }
    else { newLikelyActions.push(newLikelyAction); }
    setLikelyActions(newLikelyActions);
  }

  const getLikelyActionOptions = (likelyAction, likelyActionIndex) => {
    const newLikelyActionsOptions = [...likelyActionsOptions];
    return newLikelyActionsOptions?.map((option, optionIndex) => (
      <span key={option} className="mx-2" >
        <input className="mr-2 mt-1" type="radio" id={`likelyAction_${likelyActionIndex}_${optionIndex}`} name={`likelyAction_${likelyActionIndex}`} value={`${likelyAction},${option.name}`} onChange={(e) => { handleLikelyActionsChange(likelyAction, option); }} />
        <label htmlFor={`likelyAction_${likelyActionIndex}_${optionIndex}`} >{option}</label>
      </span>
    ));
  }
  //adobe analytics
  const formStart = () => {
    setuserInteracted(true);
    if (userInteracted == false) {
      let contEventObj = getAdobeAnalyticsEventObject(
        "form-interaction",
        "form-interaction",
      );
      // let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
      let customLObj = getAdobeAnalyticsCustomLinkObj(
        'form-interaction',
        "feedback-form",
      );
      let feedbackTrack = {
        event: "form-interaction",
        eventInfo: "form-interaction",
        form: {
          action: "form-start",
          formName: "feedback-form",
          formError: "Not available",
        }
      }

      pushDatatoAdobeLayer({
        // customLinkData: { ...customEventObj, ...customLObj },
        onContClickData: { ...contEventObj, ...feedbackTrack },
        pageData: false,
        adobePushTracking: false,
      });
    }
  }
  const feedbacksubmit = () => {
    let contEventObj = getAdobeAnalyticsEventObject(
      "form-interaction",
      "form-interaction",
    );
    // let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
    let customLObj = getAdobeAnalyticsCustomLinkObj(
      'form-interaction',
      "feedback-form",
      getUrlWithoutPathname()

    );
    let feedbackTrack = {
      event: "form-interaction",
      eventInfo: "form-interaction",
      form: {
        action: "form-completed",
        formName: "feedback-form",
        formError: "Not available",
      }
    }

    pushDatatoAdobeLayer({
      // customLinkData: { ...customEventObj, ...customLObj },
      onContClickData: { ...contEventObj, ...feedbackTrack },
      pageData: false,
      adobePushTracking: false,
    });
  }
  return (

    <div className="text-gray-brand-700">

      <h1 className="flex flex-col mb-5 font-light text-4xl text-center title-font">

        {contentKey && post ? (
          <>
            <span className="text-gray-brand-600 mb-2">Give us your feedback on:</span>
            <span className="text-gray-brand-700 text-xl mb-2">{post ? post.title : "standards+"}</span>
          </>
        ) : (
          <span className="mb-2">Tell us about your experience with PMIstandards+</span>
        )}

      </h1>

      {contentKey && post && (
        <img className="mb-16 w-2/3 mx-auto border-2 border-gray-brand-400 rounded-sm" src={post.previewImage} />
      )}

      <h4 className="font-bold mb-2">
        {`Rate your overall experience with `}
        <span>{contentKey && post ? (<><span>the post </span><b>{post.title}</b></>) : (<b>PMIstandards+</b>)}</span>
      </h4>

      <h4 className="mb-8 text-sm sm:text-base">
        <span className="">Select one: </span>
        <span className="">(</span>
        <label htmlFor="satisfiedEmoji" className="text-green-brand-700"> Satisfied</label>,
        <label htmlFor="neutralEmoji" className="text-yellow-brand-700"> Neutral</label>,
        <label htmlFor="unsatisfiedEmoji" className="text-red-brand-700"> Unsatisfied</label>
        <span className=""> )</span>
      </h4>

      <div className="text-center mb-16">

        <div className={cx("flex flex-row justify-center p-4 rounded", {
          "sm:border border-gray-brand-500 outline-none shadow-outline": focusedEmoji !== "",
          "sm:border border-gray-brand-500": focusedEmoji === ""
        })}>
          <span
            className={cx("flex items-center btn border-4 text-white mx-2 sm:mx-3 text-6xl cursor-pointer rounded-lg px-4 py-2 hover:bg-green-brand-700 relative", {
              "bg-green-brand-700": ratingValue === satisfied,
              "bg-green-brand-500": ratingValue !== satisfied,
              "border-blue-brand-500": ratingValue === satisfied || focusedEmoji === satisfied,
              "border-green-brand-500 bg-green-brand-500 hover:border-green-brand-700": ratingValue !== satisfied,
            })}
            onClick={() => { handleEmojiClick(satisfied); formStart() }}
            onKeyPress={handleEmojiKeyPres}
          >

            <i className="text-3xl far fa-smile"></i>

            <input
              ref={satisfiedEmoji}
              id="satisfiedEmoji"
              className="opacity-0 absolute right-0 bottom-0 outline-none mr-1 mb-1"
              type="radio"
              value={satisfied}
              name="emoji"
              onChange={handleRationgValueChange}
              onFocus={handleEmojiFocus}
              onBlur={() => handleEmojiBlur(satisfied)} />

          </span>
          <span
            className={cx("flex items-center btn border-4 text-white mx-2 sm:mx-3 text-6xl cursor-pointer rounded-lg px-4 py-2 hover:bg-yellow-brand-700 relative", {
              "bg-yellow-brand-700": ratingValue === neutral,
              "bg-yellow-brand-500": ratingValue !== neutral,
              "border-blue-brand-500": ratingValue === neutral || focusedEmoji === neutral,
              "border-yellow-brand-500 bg-yellow-brand-500 hover:border-yellow-brand-700": ratingValue !== neutral,
            })}
            onClick={() => { handleEmojiClick(neutral); formStart() }}
            onKeyPress={handleEmojiKeyPres}
          >

            <i className="text-3xl far fa-meh"></i>

            <input
              ref={neutralEmoji}
              id="neutralEmoji"
              className="opacity-0 absolute right-0 bottom-0 outline-none mr-1 mb-1"
              type="radio"
              value={neutral}
              name="emoji"
              onChange={handleRationgValueChange}
              onFocus={handleEmojiFocus}
              onBlur={() => handleEmojiBlur(neutral)} />

          </span>

          <span
            className={cx("flex items-center btn border-4 text-white mx-2 sm:mx-3 text-6xl cursor-pointer rounded-lg px-4 py-2 hover:bg-red-brand-700 relative", {
              "bg-red-brand-700": ratingValue === unsatisfied,
              "bg-red-brand-500": ratingValue !== unsatisfied,
              "border-blue-brand-500": ratingValue === unsatisfied || focusedEmoji === unsatisfied,
              "border-red-brand-500 bg-red-brand-500 hover:border-red-brand-700": ratingValue !== unsatisfied,
            })}
            onClick={() => { handleEmojiClick(unsatisfied); formStart() }}
            onKeyPress={handleEmojiKeyPres}
          >

            <i className="text-3xl far fa-frown"></i>

            <input
              ref={unsatisfiedEmoji}
              id="unsatisfiedEmoji"
              className="opacity-0 absolute right-0 bottom-0 outline-none mr-1 mb-1"
              type="radio"
              value={unsatisfied}
              name="emoji"
              onChange={handleRationgValueChange}
              onFocus={handleEmojiFocus}
              onBlur={() => handleEmojiBlur(unsatisfied)} />

          </span>


        </div>

      </div>

      {contentKey ? (

        // Content Feedback Form

        <div className="mb-12">

          <label htmlFor="generalFeedback" className="inline-block mb-4 font-bold">Please provide any feedback about the content.</label>

          <textarea
            className="border border-gray-brand-500 w-full p-4"
            id="generalFeedback"
            value={messageValue}
            onChange={(e) => { setMessageValue(e.target.value) }}
            onClick={formStart}
            maxLength="1000"
            rows="10"
          ></textarea>

          <p className="text-xs mt-2 mb-8">1000 character limit</p>

          <div className="mb-12">

            <label htmlFor="improvements" className="inline-block mb-4 font-bold">What improvements would enhance future content about this topic?</label>

            <textarea
              className="border border-gray-brand-500 w-full p-4"
              id="improvements"
              value={improvementsValue}
              onChange={(e) => { setimprovementsValue(e.target.value) }}
              onClick={formStart}
              maxLength="1000"
              rows="10"
            ></textarea>

            <p className="text-xs mt-2 mb-8">1000 character limit</p>

          </div>

        </div>

      ) : (

        // General Feedback Form

        <>

          <div className="mb-12">
            <p className="mb-4 font-bold">Which of the following potential features do you think is most valuable?</p>
            {contentTypeOptions?.map((option, index) => {
              if (option.type === constants.commentOptionGroupKeys.ValuableFeatures) {
                return (
                  <p key={option.id} className="pl-4 mb-4 flex flex-row">
                    <input className="mr-2 mt-1" type="radio" id={`ValuableFeatures_${index}`} name="mostValuable" value={`${option.id},${option.name}`} onChange={(e) => { setMostValuable({ id: option.id, name: option.name }); }} />
                    <label htmlFor={`ValuableFeatures_${index}`}>{option.name}</label>
                  </p>
                )
              }
            })}
          </div>

          <div className="mb-12">

            <label htmlFor="updateFrequency" className="inline-block mb-4 font-bold">How often would you prefer to see updated content posted to PMIstandards+?</label>

            <Select
              id="updateFrequency"
              value={updateFrequency}
              options={getCommentOptions(constants.commentOptionGroupKeys.CommunicationFrequency)}
              onChange={setUpdateFrequency}
            ></Select>

          </div>

          <div className="mb-12">

            <label htmlFor="costPreference" className="inline-block mb-4 font-bold">If PMIStandards+ was available as a monthly subscription, how much would you be willing to pay per month?</label>

            <Select
              id="costPreference"
              value={costPreference}
              options={getCommentOptions(constants.commentOptionGroupKeys.CostPreference)}
              onChange={setCostPreference}
            ></Select>

          </div>

          <div className="mb-12">

            <p className="inline-block mb-4 font-bold">If PMIstandards+ was a PMI member benefit, how likely are you to take the following actions:</p>

            {
              contentTypeOptions?.map((likelyAction, likelyActionIndex) => {

                if (likelyAction.type === constants.commentOptionGroupKeys.LikelyActions) {

                  return (
                    <div key={`likelyAction_${likelyActionIndex}`} className="flex flex-row justify-between mb-2" >
                      <span className="inline-block mx-2">{likelyAction.name}</span>
                      <div className="flex flex-row justify-between">
                        {getLikelyActionOptions(likelyAction, likelyActionIndex,)}
                      </div>
                    </div>
                  )
                }

              })
            }

          </div>

          <div className="mb-8">

            <label htmlFor="notificationPreference" className="inline-block mb-4 font-bold">How would you like to be notified about regular content/product updates?</label>

            <div className="relative mb-8">
              <Select
                id="notificationPreference"
                value={notificationPreference}
                options={getCommentOptions(constants.commentOptionGroupKeys.CommunicationMode)}
                onChange={setNotificationPreference}
              ></Select>
            </div>

            {notificationPreference?.value?.name === "Other" &&

              <div className="mb-8">

                <label className="block text-gray-brand-700 text-sm font-bold mb-2" htmlFor="otherNotification">Other Notification</label>

                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-brand-700 leading-tight focus:outline-none focus:shadow-outline mb-2"
                  id="otherNotification"
                  type="text"
                  placeholder="Enter other notification"
                  onChange={(e) => setotherNotification(e.target.value)}
                  maxLength="300"
                />

                <p className="text-xs mt-2 mb-8">300 character limit</p>

              </div>
            }

          </div>

          <div className="mb-8">

            <label htmlFor="contentFeedback" className="inline-block mb-4 font-bold">Please provide any feedback about this content.</label>

            <textarea
              className="border border-gray-brand-500 w-full p-4"
              id="contentFeedback"
              value={messageValue}
              onChange={(e) => setMessageValue(e.target.value)}
              maxLength="1000"
              rows="10"
            ></textarea>

            <p className="text-xs mt-2 mb-8">1000 character limit</p>

          </div>

        </>

      )}

      <div className="text-center">
        <button
          className={cx("text-white font-bold text-lg py-2 px-4 rounded ", {
            "bg-blue-brand-700": formFilled(),
            "bg-gray-brand-700": !formFilled(),
          })}
          disabled={!formFilled()}
          onClick={() => { submitForm(); feedbacksubmit() }}
        >
          SEND FEEDBACK
        </button>
      </div>

    </div>

  );
};

export default FeedbackForm;
